import React from 'react';
import styles from './SetupCard.module.scss';
import { SetupProps } from 'LearningManager/constants/createAssignment.constant';
import { Icon } from 'Components';
import classNames from 'classnames';

interface SetupCardComponentProps extends SetupProps {
	id?: string;
}

const SetupCard: React.FC<SetupCardComponentProps> = ({
	id,
	title,
	icon,
	selectedIcon,
	subTitle,
	listTitle,
	list,
	isRecommended,
	isActive,
	onClick
}) => {
	return (
		<div
			id={id}
			className={classNames(styles.container, {
				[styles['container--active']]: isActive
			})}
			onClick={onClick}
		>
			{isRecommended && <RecommendTag />}
			<div className={styles['heading-container']}>
				<div
					className={classNames(styles.heading, {
						[styles['heading--active']]: isActive
					})}
				>
					<div
						className={classNames(styles.icon, {
							[styles['icon--active']]: isActive
						})}
					>
						{isActive && selectedIcon ? selectedIcon : icon}
					</div>
					{title}
				</div>
				<div className={styles.subHeading}>{subTitle}</div>
			</div>
			<div className={styles.divider} />
			<div>{listTitle}</div>
			<ul className={styles.list}>
				{list.map((el, index) => (
					<li key={index}>{el}</li>
				))}
			</ul>
		</div>
	);
};

const RecommendTag = () => {
	return (
		<div className={styles.recommended}>
			<Icon type="reccStarsIcon" role="img" />
			Recommended
		</div>
	);
};

export default SetupCard;
